module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Aanhef")]), _vm._v(" "), (_vm.entity.name == 'amigo') ? _c('th', [_vm._v("Voornaam")]) : _c('th', [_vm._v("Voorletters")]), _vm._v(" "), _c('th', [_vm._v("Achternaam")]), _vm._v(" "), _c('th', [_vm._v("Woonplaats")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.participants), function(participant) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(participant.salutation))]), _vm._v(" "), (_vm.entity.name == 'amigo') ? _c('td', [_vm._v(_vm._s(_vm.getFirstname(participant)))]) : _c('td', [_vm._v(_vm._s(participant.initials))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(participant.middlename) + " " + _vm._s(participant.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(participant.city))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadParticipantsList()
      }
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _vm._m(1)])])], 1)]), _vm._v(" "), (!_vm.isLoading && _vm.showAgeCategories) ? _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Percentage mannelijk")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.malePercentage) + "%")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Percentage vrouwelijk")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.femalePercentage) + "%")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Gemiddelde leeftijd")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.averageAge))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Groepsgrootte")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.groupSize))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _vm._l((_vm.ageCategories), function(ageCategory) {
    return _c('tr', [_c('th', {
      attrs: {
        "col-md-6": ""
      }
    }, [_vm._v(_vm._s(ageCategory.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "col-md-4": ""
      }
    }, [_vm._v(_vm._s(ageCategory.percentage) + "%")])])
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Deelnemers "), _c('i', {
    staticClass: "fa fa-users pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('small', {
    staticClass: "pull-right text-info sub-text"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Groepssamenstelling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Leeftijd")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v("%")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d46cd1a8"}!./src/templates/reservations/participants.html
// module id = 551
// module chunks = 1